import PropTypes from 'prop-types'
import React, { Fragment, useContext, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { MenuContext } from './context/menuContext'

const MENU_AYUDA = 70
const CONVERTIR_TIENDA_OFICIAL = 39

const MenuPrincipal = (props) => {
  const navigate = useNavigate()
  const { menus, desplegarMenu, menuAbierto, nav } = useContext(MenuContext)
  const { loginDataContext: { tipoUsuario } = {} } = useAuth()
  const [idMenuAbrir, setMenuAbrir] = useState(0)
  const [subMenuAbierto, setSubMenuAbierto] = useState(false)

  // Reset submenu states when main menu closes
  useEffect(() => {
    if (!menuAbierto) {
      setMenuAbrir(0)
      setSubMenuAbierto(false)
    }
  }, [menuAbierto])

  useEffect(() => {
    if (!menuAbierto) return
    const handleClickOutside = (e) => {
      if (
        nav.current &&
        !nav.current.contains(e.target) &&
        !e.target.closest('[data-menu-toggle]')
      ) {
        desplegarMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuAbierto, nav, desplegarMenu])

  const toggle = (idMenu) => {
    setMenuAbrir(idMenu)
    if (idMenu === idMenuAbrir) {
      setSubMenuAbierto(!subMenuAbierto)
    } else {
      setSubMenuAbierto(false)
    }
    if (idMenu === MENU_AYUDA) {
      props.mostrarAyuda()
    }
  }

  const handleMenuNavigation = () => {
    desplegarMenu(false)
  }

  return (
    <nav
      ref={nav}
      className={`vertical_nav ocultarScroll ${
        menuAbierto ? 'vertical_nav__opened' : 'vertical_nav__closed'
      }`}
    >
      <div className="menu-panel">
        <ul>
          {menus
            .filter((menu) => menu.idMenuPosicion === 1 && menu.idMenuPadre === 0)
            .map((menuPrincipal) => (
              <Fragment key={menuPrincipal.idMenu}>
                <li
                  className="aside-menu-icon menuDesplegarMenu"
                  id={menuPrincipal.idMenu}
                  onClick={() => {
                    if (menuPrincipal.link) {
                      if (menuPrincipal.idMenu === MENU_AYUDA) {
                        props.mostrarAyuda()
                      } else {
                        navigate(`/${menuPrincipal.link}`)
                        desplegarMenu(false)
                      }
                    } else {
                      toggle(menuPrincipal.idMenu)
                    }
                  }}
                >
                  {menuPrincipal.link && menuPrincipal.idMenu !== MENU_AYUDA ? (
                    <Link
                      to={`/${menuPrincipal.link}`}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleMenuNavigation()
                      }}
                    >
                      <i className={`${menuPrincipal.icono} fa-fw`} aria-hidden="true" />
                      {menuPrincipal.nombre}
                    </Link>
                  ) : (
                    <>
                      <i className={`${menuPrincipal.icono} fa-fw`} aria-hidden="true" />
                      {menuPrincipal.idMenu === MENU_AYUDA ? (
                        <span className="aside-menu-icon">{menuPrincipal.nombre}</span>
                      ) : (
                        menuPrincipal.nombre
                      )}
                    </>
                  )}
                </li>

                {!menuPrincipal.link && menuPrincipal.idMenu === idMenuAbrir && !subMenuAbierto && (
                  <ul className="sub-menu">
                    {menus
                      .filter((menuS) => {
                        if (menuS.idMenuPadre !== menuPrincipal.idMenu) return false
                        if (tipoUsuario === 'R' && menuS.idMenu === CONVERTIR_TIENDA_OFICIAL)
                          return false
                        return true
                      })
                      .map((subMenu) => (
                        <li key={subMenu.idMenu} id={subMenu.idMenu}>
                          <Link
                            to={`/${subMenu.link}`}
                            onClick={(e) => {
                              e.stopPropagation()
                              handleMenuNavigation()
                            }}
                          >
                            {subMenu.nombre}
                          </Link>
                        </li>
                      ))}
                  </ul>
                )}
              </Fragment>
            ))}
        </ul>
      </div>
    </nav>
  )
}

MenuPrincipal.propTypes = {
  mostrarAyuda: PropTypes.func.isRequired
}

export default React.memo(MenuPrincipal)
